import { useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LayoutAuth from '../../components/LayoutAuth';
import VerificationContent from './components/VerificationContent';
import api from '../../utils/api/index';
import { useEffect } from 'react';
import { setCookie } from '../../utils/cookies';
import { useConfig } from '../../Hooks/useConfig';
import { useAuthStatus } from '../../store/auth/useAuthStatus';
import useUsersFacade from '../../store/profile/useUsersFacade';
import { Helmet } from 'react-helmet-async';

const Verification = () => {
  let route = useLocation();
  let [verifiStatus, setVerifiStatus] = useState(false);
  let [loading, setLoading] = useState(true);
  let { baseDomain } = useConfig();

  // zustand
  const { fetchUsers } = useUsersFacade();
  const { setToken } = useAuthStatus();

  const VerifyEmailToken = async () => {
    setLoading(true);
    let token = route.search.replace('?token=', '');
    let VerifyEmailTokenReq = await api.call({
      name: 'verifyEmailToken',
      data: {
        token,
      },
    });
    setLoading(false);
    if (VerifyEmailTokenReq.status === 400) {
      setVerifiStatus(false);
    }
    if (VerifyEmailTokenReq.status === 200) {
      fetchUsers();
      setVerifiStatus(true);
      setCookie(
        'token',
        VerifyEmailTokenReq.data.data.token,
        VerifyEmailTokenReq.data.data.expires_in,
        baseDomain
      );
      setToken(register.data.data.token);
    }
  };
  useEffect(() => {
    VerifyEmailToken();
  }, []);
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <VerificationContent verifiStatus={verifiStatus} loading={loading} />
    </>
  );
};
export default Verification;
